import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../../utilerias/constantes/urlconstantes";
import { PinAutorizadorReq, PinAutorizadorRes } from "../../shared/model/security/pin-autorizador.model";

/**
 * El PIN personal del autorizador: de plataforma, no de un módulo. Cada
 * quien lo define y lo cambia en Ajustes; quien administra Empleados lo
 * restablece. Los módulos que autorizan (Homologación de Modelos IA) lo
 * mandan en su propia petición y lo revisa el servidor.
 *
 * El usuario nunca viaja en la petición: el servidor lo toma de la sesión.
 */
@Injectable({ providedIn: "root" })
export class PinAutorizadorService {
  constructor(private http: HttpClient) {}

  /** Mi estado; con idUsuario, el de otra persona (solo Empleados). */
  estado(idUsuario?: number): Observable<PinAutorizadorRes> {
    const req: PinAutorizadorReq = idUsuario != null ? { idUsuario } : {};
    return this.http.post<PinAutorizadorRes>(UrlConstantes.PIN_AUTORIZADOR_ESTADO, req);
  }

  /** La primera vez: con la contraseña de COS. */
  establecer(password: string, pinNuevo: string): Observable<PinAutorizadorRes> {
    const req: PinAutorizadorReq = { password, pinNuevo };
    return this.http.post<PinAutorizadorRes>(UrlConstantes.PIN_AUTORIZADOR_ESTABLECER, req);
  }

  /** Con el PIN actual, que cuenta como intento. */
  cambiar(pin: string, pinNuevo: string): Observable<PinAutorizadorRes> {
    const req: PinAutorizadorReq = { pin, pinNuevo };
    return this.http.post<PinAutorizadorRes>(UrlConstantes.PIN_AUTORIZADOR_CAMBIAR, req);
  }

  /** Borra el PIN de otra persona para que defina uno nuevo. Solo Empleados. */
  restablecer(idUsuario: number): Observable<PinAutorizadorRes> {
    const req: PinAutorizadorReq = { idUsuario };
    return this.http.post<PinAutorizadorRes>(UrlConstantes.PIN_AUTORIZADOR_RESTABLECER, req);
  }
}
